import React from 'react';

import './Homepage.scss'

import AwaitingYourAction from './components/awaitingYourAction/awaitingYourAction'
import QuickTasks from './components/quickTasks/quickTasks'
import Announcements from './components/announcements/announcements'
import TimelySuggestions from './components/timelySuggestions/timelySuggestions'
import YourTeam from './components/yourTeam/yourTeam';
import Schedule from './components/schedule/schedule';
import CreatePositionModal from './components/createPositionModal/createPositionModal';
import CreatePositionFinishedModal from './components/createPositionFinishedModal/createPositionFinishedModal';
import CreateCostCenterModal from './components/createCostCenterModal/createCostCenterModal';

import { useHistory, useLocation } from 'react-router-dom';

const Homepage = (props) => {
    const { search } = useLocation();
    const history = useHistory();
    const parameters = new URLSearchParams(search);
    const process = parameters.get('process');

    // The URL is the single source of truth for which process modal is open.
    // Every entry point (Quick Task tile, search result, direct link) pushes
    // /?process=<name>, and closing a modal removes the parameter again.
    const openProcess = (name) => history.push(`/?process=${name}`);
    const closeProcess = () => history.push('/');

    return (
        <div className='homepage'>
            <CreatePositionModal isOpen={process === 'createPosition'} onChange={closeProcess}/>
            <CreateCostCenterModal isOpen={process === 'createCostCenter'} onChange={closeProcess}/>
            <CreatePositionFinishedModal isOpen={process === 'createPositionFin'} onChange={closeProcess}/>
            <img src="https://www.publicdomainpictures.net/pictures/220000/velka/scenic-mountain-landscape-1491664544hse.jpg" className='banner' alt=""/>
            <div className='bodyWrapper'>
                <div className='left'>
                    <h1>Welcome</h1>
                    <AwaitingYourAction/>
                    <TimelySuggestions/>
                    <YourTeam/>
                </div>
                <div className='right'>
                    <p className='date'>It's Sunday, July 27, 2024</p>
                    <Announcements/>
                    <QuickTasks cpOnClick={() => openProcess('createPosition')} ccOnClick={() => openProcess('createCostCenter')}/>
                    <Schedule/>
                </div>
            </div>
        </div>
    )
}

export default Homepage
